import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import ImageCropper from "../Common/ImageCropper";
import Upload from "../Common/upload-image/Upload";
import getCroppedImg from "../../helpers/CropImage";
import { Range, getTrackBackground } from "react-range";
import ImageKit from "imagekit-javascript";
import { VIEW_ROLE } from "../../query/ViewRole";
import { hasuraClient } from "../../apolloClient";
import { useQuery } from "@apollo/react-hooks";

const ImageCrop = (props) => {
  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  const [savingData, setsavingData] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [imageUrl, setImageUrl] = useState(null);
  const [zoom, setZoom] = useState([1]);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState({
    width: 100,
    height: 100,
  });
  const [cropImage, setCropImage] = useState(null);

  const imageKit = new ImageKit({
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    urlEndpoint: process.env.REACT_APP_URL_END_POINT,
    authenticationEndpoint: process.env.REACT_APP_AUTHENTICATION_END_POINT,
  });

  const changeImageUrl = (date) => {
    setZoom([1]);
    setImageUrl(date);
  };

  const handleImageUpload = async (croppedImage) => {
    if (croppedImage !== null) {
      setsavingData(true);
      await imageKit.upload(
        {
          file: croppedImage,
          fileName: `cropped_image _${Math.random}`,
          tags: ["tag1"],
          folder: `/dev/business_profile/${localStorage.getItem("profile_id")}`,
        },
        (err, result) => {
          if (result) {
            if (props.ImageType === "header") {
              props
                .BusinessProfile({
                  variables: {
                    data: {
                      business_profile_photo: imageKit.url({
                        src: result.url,
                      }),
                      business_profile_path: `/dev/business_profile/${localStorage.getItem(
                        "profile_id"
                      )}`,
                    },
                    userId: props.data?.users[0]?.id
                      ? props.data.users[0].id
                      : "",
                  },
                })
                .then(() => {
                  setsavingData(false);
                  setCropImage(null);
                  setImageUrl(null);
                  setZoom([1]);
                  props.refetch();
                  props.onHide();
                })
                .catch(() => {
                  setsavingData(false);
                });
            } else {
              props
                .BusinessProfile({
                  variables: {
                    data: {
                      business_cover_photo: imageKit.url({
                        src: result.url,
                      }),
                      business_cover_path: `/dev/business_profile/${localStorage.getItem(
                        "profile_id"
                      )}`,
                    },
                    userId: props.data?.users[0]?.id
                      ? props.data.users[0].id
                      : "",
                  },
                })
                .then(() => {
                  setsavingData(false);

                  setCropImage(null);
                  setImageUrl(null);
                  setCropImage(null);
                  setZoom([1]);
                  props.refetch();
                  props.onHide();
                })
                .catch(() => {
                  setsavingData(false);
                });
            }
          }
        }
      );
    } else {
      props
        .BusinessProfile({
          variables: {
            data: {
              business_cover_photo: imageUrl ? imageUrl : props.currentPhoto,
              business_cover_path: `/dev/business_profile/${localStorage.getItem(
                "profile_id"
              )}`,
            },
            userId: props.data?.users[0]?.id ? props.data.users[0].id : "",
          },
        })
        .then(() => {
          setCropImage(null);
          setImageUrl(null);
          setCropImage(null);
          setZoom([1]);
          props.refetch();
          props.onHide();
        })
        .catch(() => {});
    }
  };

  const handleImageUploadClub = async (croppedImage) => {
    if (croppedImage !== null) {
      await imageKit.upload(
        {
          file: croppedImage,
          fileName: `cropped_image _${Math.random}`,
          tags: ["tag1"],
          folder: `/dev/club_profile/${localStorage.getItem("profile_id")}`,
        },
        (err, result) => {
          if (result) {
            if (props.ImageType === "header") {
              props
                .BusinessProfile({
                  variables: {
                    data: {
                      profile_photo: imageKit.url({
                        src: result.url,
                      }),
                      profile_path: `/dev/club_profile/${localStorage.getItem(
                        "profile_id"
                      )}`,
                    },
                    userId: props.data?.users[0]?.id
                      ? props.data.users[0].id
                      : "",
                  },
                })
                .then(() => {
                  setCropImage(null);
                  setImageUrl(null);
                  setZoom([1]);
                  props.refetch();
                  props.onHide();
                  setsavingData(false);
                })
                .catch(() => {
                  setsavingData(false);
                });
            } else {
              props
                .BusinessProfile({
                  variables: {
                    data: {
                      cover_photo: imageKit.url({
                        src: result.url,
                      }),
                      cover_path: `/dev/club_profile/${localStorage.getItem(
                        "profile_id"
                      )}`,
                    },
                    userId: props.data?.users[0]?.id
                      ? props.data.users[0].id
                      : "",
                  },
                })
                .then(() => {
                  setsavingData(false);

                  setCropImage(null);
                  setImageUrl(null);
                  setCropImage(null);
                  setZoom([1]);
                  props.refetch();
                  props.onHide();
                })
                .catch(() => {
                  setsavingData(false);
                });
            }
          } else {
            setsavingData(false);
          }
        }
      );
    } else {
      props
        .BusinessProfile({
          variables: {
            data: {
              cover_photo: imageUrl ? imageUrl : props.currentPhoto,
              cover_path: `/dev/club_profile/${localStorage.getItem(
                "profile_id"
              )}`,
            },
            userId: props.data?.users[0]?.id ? props.data.users[0].id : "",
          },
        })
        .then(() => {
          setsavingData(false);
          setCropImage(null);
          setImageUrl(null);
          setCropImage(null);
          setZoom([1]);
          props.refetch();
          props.onHide();
        })
        .catch(() => {
          setsavingData(false);
        });
    }
  };

  const onCropChange = (cropped) => {
    setCrop(cropped);
    showCroppedImage();
  };

  const onCropComplete = (croppedArea, croppedAreaPixelsData) => {
    setCroppedAreaPixels(croppedAreaPixelsData);
  };
  const onZoomChange = (zoomValue) => {
    setZoom(zoomValue);
  };

  const showCroppedImage = async () => {
    const croppedImage = await getCroppedImg(
      imageUrl ? imageUrl : props.currentPhoto,
      croppedAreaPixels
    );
    setCropImage(croppedImage);
  };
  return (
    <Modal
      className="imagecrop-modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => {
          setsavingData(false);
          setImageUrl(null);
        }}
      ></Modal.Header>
      <Modal.Body>
        <div className="imagecrop-body">
          <h2>{props.popupTitle}</h2>
          <ImageCropper
            currentPhoto={imageUrl ? imageUrl : props.currentPhoto}
            crop={crop}
            setCrop={setCrop}
            zoom={zoom}
            setZoom={setZoom}
            onCropComplete={onCropComplete}
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
          />
        </div>

        <div className="rangeslider-row">
          <div className="range-input">
            <label>Zoom</label>
            <Range
              min={1}
              max={7}
              values={zoom}
              onChange={(e) => {
                onZoomChange(e);
                showCroppedImage();
              }}
              renderThumb={({ props, isDragged }) => (
                <div className="range-circle" {...props}>
                  <div
                    style={{
                      backgroundColor: isDragged ? "#696AE7" : "#E8E9EB",
                    }}
                  />
                </div>
              )}
              renderTrack={({ props, children }) => (
                <div
                  onMouseDown={props.onMouseDown}
                  onTouchStart={props.onTouchStart}
                  style={{
                    ...props.style,
                    height: "36px",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div
                    ref={props.ref}
                    style={{
                      height: "5px",
                      width: "100%",
                      borderRadius: "4px",
                      background: getTrackBackground({
                        values: zoom,
                        colors: ["#696AE7", "#E8E9EB"],
                        min: 1,
                        max: 7,
                      }),
                      alignSelf: "center",
                    }}
                  >
                    {children}
                  </div>
                </div>
              )}
            />
            <output id="output">{zoom[0]}</output>
          </div>
          <div className="slider-title">
            <p>Drag to reposition photo</p>
          </div>
        </div>
        {userRole?.users[0].role === "business" ? (
          <div className="button-row 1">
            <div className="delete-btn">
              <button
                className="cancel-btn"
                onClick={() => {
                  if (props.ImageType === "header") {
                    props
                      .BusinessProfile({
                        variables: {
                          data: {
                            business_profile_photo: null,
                            business_profile_path: null,
                          },
                          userId: props.data?.users[0]?.id
                            ? props.data.users[0].id
                            : "",
                        },
                      })
                      .then(() => {
                        setImageUrl(null);
                        setZoom([1]);
                        props.refetch();
                        props.onHide();
                      })
                      .catch(() => {});
                  } else {
                    props
                      .BusinessProfile({
                        variables: {
                          data: {
                            business_cover_photo: null,
                            business_cover_path: null,
                          },
                          userId: props.data?.users[0]?.id
                            ? props.data.users[0].id
                            : "",
                        },
                      })
                      .then(() => {
                        setImageUrl(null);
                        setCropImage(null);
                        setZoom([1]);
                        props.refetch();
                        props.onHide();
                      })
                      .catch(() => {});
                  }
                }}
              >
                delete Photo
              </button>
            </div>
            <div className="submit-row">
              <Upload
                type="change"
                data={props.data}
                refetch={props.refetch}
                BusinessProfile={props.BusinessProfile}
                setImageUrl={changeImageUrl}
                ImageType={props.ImageType}
              />
              <div
                onClick={() => {
                  handleImageUpload(cropImage);
                }}
                className="button"
                style={{ cursor: "pointer" }}
              >
                save
              </div>
            </div>
          </div>
        ) : (
          <div className="button-row 2">
            <div className="delete-btn">
              <button
                className="cancel-btn"
                onClick={() => {
                  if (props.ImageType === "header") {
                    props
                      .BusinessProfile({
                        variables: {
                          data: {
                            profile_photo: null,
                            profile_path: null,
                          },
                          userId: props.data?.users[0]?.id
                            ? props.data.users[0].id
                            : "",
                        },
                      })
                      .then(() => {
                        setImageUrl(null);
                        setZoom([1]);
                        props.refetch();
                        props.onHide();
                      })
                      .catch(() => {});
                  } else {
                    props
                      .BusinessProfile({
                        variables: {
                          data: {
                            cover_photo: null,
                            cover_path: null,
                          },
                          userId: props.data?.users[0]?.id
                            ? props.data.users[0].id
                            : "",
                        },
                      })
                      .then(() => {
                        setImageUrl(null);
                        setCropImage(null);
                        setZoom([1]);
                        props.refetch();
                        props.onHide();
                      })
                      .catch(() => {});
                  }
                }}
              >
                delete Photo
              </button>
            </div>
            <div className="submit-row">
              <div
                style={{
                  width: "191px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Upload
                  type="change"
                  data={props.data}
                  refetch={props.refetch}
                  BusinessProfile={props.BusinessProfile}
                  setImageUrl={changeImageUrl}
                  ImageType={props.ImageType}
                />
              </div>
              {savingData ? (
                <div
                  style={{
                    width: "191px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "17px",
                    marginRight: "25px",
                  }}
                >
                  <Spinner className="spinner" animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <div
                  onClick={() => {
                    setsavingData(true);
                    handleImageUploadClub(cropImage);
                  }}
                  className="button"
                  style={{ cursor: "pointer", position: "relative" }}
                >
                  save
                </div>
              )}
            </div>
          </div>
        )}
        {/* <div className="button-row 3">
          <div className="delete-btn">
            <button
              className="cancel-btn"
              onClick={() => {
                if (props.ImageType === "header") {
                  props
                    .BusinessProfile({
                      variables: {
                        data: {
                          profile_photo: null,
                          profile_path: null,
                        },
                        userId: props.data?.users[0]?.id
                          ? props.data.users[0].id
                          : "",
                      },
                    })
                    .then(() => {
                      setImageUrl(null);
                      setZoom([1]);
                      props.refetch();
                      props.onHide();
                    })
                    .catch(() => {});
                } else {
                  props
                    .BusinessProfile({
                      variables: {
                        data: {
                          cover_photo: null,
                          cover_path: null,
                        },
                        userId: props.data?.users[0]?.id
                          ? props.data.users[0].id
                          : "",
                      },
                    })
                    .then(() => {
                      setImageUrl(null);
                      setCropImage(null);
                      setZoom([1]);
                      props.refetch();
                      props.onHide();
                    })
                    .catch(() => {});
                }
              }}
            >
              delete Photo
            </button>
          </div>
          <div className="submit-row">
            <Upload
              type="change"
              data={props.data}
              refetch={props.refetch}
              BusinessProfile={props.BusinessProfile}
              setImageUrl={changeImageUrl}
              ImageType={props.ImageType}
            />
            <div
              onClick={() => {
                handleImageUploadClub(cropImage);
              }}
              className="button"
              style={{ cursor: "pointer" }}
            >
              save
            </div>
          </div>
        </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default ImageCrop;
